"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentButtonHeading = getPaymentButtonHeading;
exports.getPaymentButtonDescription = getPaymentButtonDescription;
exports.getMonthlyAmount = getMonthlyAmount;
exports.getGAEventLabelByPaymentType = getGAEventLabelByPaymentType;
exports.getPaymentButtonObjects = getPaymentButtonObjects;
exports.getErrorMessage = getErrorMessage;
exports.PayFabricStatuses = exports.receiptTypes = exports.paymentTypes = exports.formTypes = void 0;

var _amexLogo = _interopRequireDefault(require("../global/images/amex-logo.jpg"));

var _dinersClubLogo = _interopRequireDefault(require("../global/images/diners-club-logo.png"));

var _discoverLogo = _interopRequireDefault(require("../global/images/discover-logo.png"));

var _jcbLogo = _interopRequireDefault(require("../global/images/jcb-logo.png"));

var _mastercardLogo = _interopRequireDefault(require("../global/images/mastercard-logo.png"));

var _unionPayLogo = _interopRequireDefault(require("../global/images/union-pay-logo.png"));

var _visaLogo = _interopRequireDefault(require("../global/images/visa-logo.jpg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formTypes;
exports.formTypes = formTypes;

(function (formTypes) {
  formTypes["spreedly"] = "spreedly";
  formTypes["splitit"] = "splitit";
})(formTypes || (exports.formTypes = formTypes = {}));

var paymentTypes;
exports.paymentTypes = paymentTypes;

(function (paymentTypes) {
  paymentTypes["savedCard"] = "savedCard";
  paymentTypes["full"] = "full";
  paymentTypes["installments"] = "installments";
})(paymentTypes || (exports.paymentTypes = paymentTypes = {}));

var receiptTypes;
exports.receiptTypes = receiptTypes;

(function (receiptTypes) {
  receiptTypes["email"] = "email";
  receiptTypes["textMessage"] = "text_message";
  receiptTypes["none"] = "no_thanks";
})(receiptTypes || (exports.receiptTypes = receiptTypes = {}));

var PayFabricStatuses = Object.freeze({
  Approved: 'Approved',
  AVSFailure: 'AVSFailure',
  Declined: 'Declined',
  Denied: 'Denied',
  Failure: 'Failure',
  MoreInfo: 'More Info'
});
exports.PayFabricStatuses = PayFabricStatuses;

function getPaymentButtonHeading(action) {
  var type = action.type;
  var lowerCase = type.toLowerCase();

  switch (lowerCase) {
    case paymentTypes.full:
      return 'One time payment';

    case paymentTypes.installments:
      return 'Pay Monthly';

    default:
      return '';
  }
}

function getPaymentButtonDescription(action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case paymentTypes.full:
      return "Pay your balance of $".concat(payload, " in full");

    case paymentTypes.installments:
      return "3, 4, 6 monthly payments available";

    default:
      return '';
  }
}

function getMonthlyAmount(total) {
  var num = typeof total === 'number' ? +total.toFixed(2) * 100 : +(+total).toFixed(2) * 100;
  var amount = (num / 6 / 100).toString(); // always show the amount for 6 installments

  return parseFloat(amount).toFixed(2);
}

function getGAEventLabelByPaymentType(paymentType) {
  switch (paymentType) {
    case paymentTypes.full:
      return 'Pay Now';

    case paymentTypes.installments:
      return 'Pay Monthly';

    default:
      return '';
  }
}

function getPaymentButtonObjects(amount) {
  var allowInstallments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var paymentMethod = arguments.length > 2 ? arguments[2] : undefined;

  var buttonTypes = _objectSpread({}, paymentTypes);

  if (!allowInstallments) {
    delete buttonTypes.installments;
  }

  if (!paymentMethod) {
    delete buttonTypes.savedCard;
  }

  var keys = Object.keys(buttonTypes);
  var btnArr = keys.map(function (btn) {
    return {
      paymentType: paymentTypes[btn],
      amount: paymentTypes[btn] === paymentTypes.installments ? getMonthlyAmount(amount) : amount,
      heading: getPaymentButtonHeading({
        type: paymentTypes[btn]
      }),
      description: getPaymentButtonDescription({
        type: paymentTypes[btn],
        payload: amount
      }),
      paymentMethod: _objectSpread(_objectSpread({}, paymentMethod), {}, {
        logo: getLogoOfPaymentMethod(paymentMethod)
      }),
      isPopular: paymentTypes[btn] === paymentTypes.installments
    };
  });
  return btnArr;
}

function getLogoOfPaymentMethod(paymentMethod) {
  if (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.card_type) {
    var _creditCardLogos$card;

    var cardType = paymentMethod.card_type;
    var creditCardLogos = {
      AMERICANEXPRESS: _amexLogo.default,
      DINERS: _dinersClubLogo.default,
      DISCOVER: _discoverLogo.default,
      JCB: _jcbLogo.default,
      MASTERCARD: _mastercardLogo.default,
      UNIONPAY: _unionPayLogo.default,
      VISA: _visaLogo.default
    };
    return (_creditCardLogos$card = creditCardLogos[cardType]) !== null && _creditCardLogos$card !== void 0 ? _creditCardLogos$card : '';
  }

  return '';
}

function getErrorMessage(payFabricStatus) {
  switch (payFabricStatus) {
    case PayFabricStatuses.AVSFailure:
      return "Your card's CVV number is not correct.";

    case PayFabricStatuses.Declined:
      return 'Your card has been declined.';

    default:
      return 'There was an error processing your payment.';
  }
}